import { Extension, getAttributes } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

const LinkBubbleMenuHandler = Extension.create({
  name: "linkBubbleMenuHandler",

  addStorage() {
    return {
      state: "HIDDEN",
      bubbleMenuOptions: undefined,
    };
  },

  addCommands() {
    return {
      openLinkBubbleMenu:
        (bubbleMenuOptions = {}) =>
        ({ editor, chain, dispatch }) => {
          let newMenuState = "HIDDEN";
          if (editor.isActive("link")) {
            chain().extendMarkRange("link").focus().run();

            newMenuState = "VIEW_LINK_DETAILS";
          }

          if (dispatch) {
            this.storage.state = newMenuState;
            this.storage.bubbleMenuOptions = bubbleMenuOptions;
          }

          return true;
        },
      closeLinkBubbleMenu:
        () =>
        ({ commands, dispatch }) => {
          const currentMenuState = this.storage.state;
          if (currentMenuState === "HIDDEN") return false;

          commands.focus();

          if (dispatch) {
            this.storage.state = "HIDDEN";
          }

          return true;
        },
    };
  },

  onSelectionUpdate() {
    if (
      this.storage.state === "VIEW_LINK_DETAILS" &&
      !this.editor.isActive("link")
    ) {
      this.editor.commands.closeLinkBubbleMenu();
    }
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("handleClickLinkForMenu"),
        props: {
          handleClick: (view, pos, event) => {
            const attrs = getAttributes(view.state, "link");
            const link = event.target.closest("a");

            if (link && attrs.href && this.storage.state === "HIDDEN") {
              this.editor.commands.openLinkBubbleMenu();
            } else {
              this.editor.commands.closeLinkBubbleMenu();
            }

            return false;
          },
        },
      }),
    ];
  },
});

export default LinkBubbleMenuHandler;
